/**
 * @generated SignedSource<<bc34395e66afe4e770e876cd057925f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUProductItemCategoryTag_PLUCategory$data = {
  readonly color: string;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "PLUProductItemCategoryTag_PLUCategory";
};
export type PLUProductItemCategoryTag_PLUCategory$key = {
  readonly " $data"?: PLUProductItemCategoryTag_PLUCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"PLUProductItemCategoryTag_PLUCategory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PLUProductItemCategoryTag_PLUCategory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "PLUCategory",
  "abstractKey": null
};

(node as any).hash = "3451a77ffebef99f84d14d3a312e9510";

export default node;
